import { useEffect } from 'react'
import { useInView } from 'react-intersection-observer'
import Masonry from 'react-masonry-css'
import { SceneCard, SceneCardSkeleton } from './components/engine-card'
import { EngineDetail } from './components/engine-detail'
import { breakpointColumnsObj } from './data/config'
import { useDiscover } from './hooks/use-discover'
import { useDiscoverStore } from './stores/discover-store'

export function Discover() {
  const {
    flatEngines,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
    isLoading,
    isFetching,
  } = useDiscover()

  // Get Slices & Handlers
  const { isDetailOpen, selectedEngine } = useDiscoverStore((s) => s.detail)
  const handlers = useDiscoverStore((s) => s.handlers)
  const { handleSelectEngine, handleCloseDetail } = handlers

  // Infinite Scroll Observer
  const { ref, inView } = useInView({
    rootMargin: '200px',
  })

  useEffect(() => {
    // 哨兵进入视口且有下一页时触发请求
    // 增加 !isFetching 判断，防止在初始加载或任一请求处理中产生重复触发
    if (inView && hasNextPage && !isFetchingNextPage && !isFetching) {
      fetchNextPage()
    }
  }, [inView, hasNextPage, isFetchingNextPage, isFetching, fetchNextPage])

  return (
    <div className='mx-auto space-y-6 pr-2'>
      {/* Content Grid */}
      {isLoading ? (
        <div className='grid grid-cols-2 gap-4 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5'>
          {Array.from({ length: 15 }).map((_, i) => (
            <div key={i} className='py-1'>
              <SceneCardSkeleton />
            </div>
          ))}
        </div>
      ) : (
        <div className='engine-grid'>
          {(!flatEngines || flatEngines.length === 0) && (
            <div className='text-muted-foreground col-span-full py-20 text-center'>
              暂无世界卡。
            </div>
          )}
          <Masonry
            breakpointCols={breakpointColumnsObj}
            className='masonry-grid flex w-auto'
            columnClassName='masonry-grid_column pl-2 bg-clip-padding'
          >
            {flatEngines.map((engine) => (
              <div key={engine.id} className='py-1'>
                <SceneCard
                  engine={engine}
                  onClick={() => handleSelectEngine(engine)}
                />
              </div>
            ))}
          </Masonry>
        </div>
      )}

      {/* Loading Sentinel */}
      <div ref={ref} className='flex flex-col items-center justify-center py-8'>
        {isFetchingNextPage ? (
          <div className='flex flex-col items-center gap-2 py-4'>
            <div className='border-primary h-5 w-5 animate-spin rounded-full border-2 border-t-transparent' />
            <div className='text-muted-foreground animate-pulse text-sm font-medium tracking-wide'>
              正在探索更多精彩内容...
            </div>
          </div>
        ) : hasNextPage ? (
          <div className='text-muted-foreground animate-pulse text-sm'>
            正在加载更多...
          </div>
        ) : flatEngines.length > 0 ? (
          <div className='text-muted-foreground text-sm'>没有更多卡片了。</div>
        ) : null}
      </div>

      {/* Detail Drawer/Modal */}
      {isDetailOpen && (
        <EngineDetail
          engine={selectedEngine}
          open={isDetailOpen}
          onOpenChange={(open) => !open && handleCloseDetail()}
        />
      )}
    </div>
  )
}
